import getFacetGroupTitle from "./facet_group_title";
import prepareFacetsGroup from "./prepare_facets_group";
import groupFacetsByLetter from "./group_facets_by_letter";
import hash from "../hash";


const prepareFacets = (facets, stats) => {
    let prepared = [];

    for (let group in facets) {
        const id = hash(group, 'g');
        const preparedFacets = prepareFacetsGroup(facets, group);

        prepared.push({
            group,
            id,
            title: getFacetGroupTitle(group),
            facets: preparedFacets,
            groupedByLetterFacets: groupFacetsByLetter(preparedFacets, group),
            stats: stats ? stats[group] ?? [] : [],
            isYearRange: group === '__year',
        });
    }

    return prepared;
};

export {prepareFacets};